import type { ObjectValues } from '@repo/common';
import type { PropsWithChildren } from 'react';

import { styled } from 'styled-components';

import { ButtonsGroup, PrimaryButton, SecondaryButton } from './buttons';
import { FailedIcon, NotFoundIcon, SuccessIcon, UnauthorizedIcon } from './icons';

import * as GSC from '@/styles/GlobalStyles';
import { fontHeadingOne, fontTextMdRegular } from '@/styles/helpers';

export const ColorVariant = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  INFO: 'INFO',
} as const;

const Title = styled.h1<{ $colorVariant: ObjectValues<typeof ColorVariant> }>`
  ${fontHeadingOne};
  margin-bottom: 6px;
  margin-top: 30px;
  text-align: center;
  color: ${(p) => {
    switch (p.$colorVariant) {
      case ColorVariant.SUCCESS:
        return p.theme.colors.emeraldGreen[100];
      case ColorVariant.ERROR:
        return p.theme.colors.alertRed[100];
      default:
        return p.theme.colors.oxfordBlue[80];
    }
  }};
`;

const Text = styled.p`
  ${fontTextMdRegular};
  color: ${(p) => p.theme.colors.oxfordBlue[80]};
  text-align: center;
`;

const ContainerSC = styled.div`
  max-width: 648px;
  margin-inline: auto;
  margin-top: 32px;

  @media (min-width: ${(p) => p.theme.devices.tablet}) {
    margin-top: 50px;
  }
`;

const Container = ({ children }: PropsWithChildren) => {
  return (
    <GSC.PageWrapper>
      <ContainerSC>{children}</ContainerSC>
    </GSC.PageWrapper>
  );
};

export {
  Container,
  Text,
  Title,
  SuccessIcon,
  FailedIcon,
  NotFoundIcon,
  UnauthorizedIcon,
  ButtonsGroup,
  PrimaryButton,
  SecondaryButton,
};
